module.exports = __webpack_public_path__ + "static/img/img06.2b5c88d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv001/img06.gif
// module id = Zc9F
// module chunks = 0